import { Type, Dom, Loc, Uri } from 'main.core';
import { EventEmitter } from 'main.core.events';
import { MessageBox, MessageBoxButtons } from 'ui.dialogs.messagebox';
import 'ui.forms';

import './style.css';

export class Manager
{
	static openCertificate(
		id = 0,
		params = {}
	) {
		let url = Loc.getMessage(
			'JS_FUSION_CERTIFICATE_MANAGER_PATH_TO_DETAIL', {
				'#ID#': id
			}
		);

		if (Type.isStringFilled(url))
		{
			let uri = new Uri(url);

			if (
				Type.isObjectLike(params)
				&& !!Object.keys(params).length
			) {
				uri.setQueryParams(params);
			}

			BX.SidePanel.Instance.open(uri.toString(), {
				width: 650,
				cacheable: false,
				copyLinkLabel: (id > 0),
				allowChangeHistory: true,
				allowChangeTitle: false,
				events: {
					onCloseComplete: (event) => {
						const sliderData = event.getSlider().getData();

						if (sliderData.get('saveSuccess')) {
							EventEmitter.emit(
								window, 
								'BX.Fusion.Certificate:onCertificateSave', 
								{}
							);
						}
					}
				}
			});
		} else {
			MessageBox.show({
				title: Loc.getMessage('JS_FUSION_CERTIFICATE_MANAGER_ERROR_TITLE'),
				message: 'URL not found',
				buttons: MessageBoxButtons.OK,
			});
		}
	}

	static deleteCertificate(id) {
		MessageBox.show({
			title: Loc.getMessage('JS_FUSION_CERTIFICATE_MANAGER_CONFIRM_DELETE_TITLE'),
			message: Loc.getMessage('JS_FUSION_CERTIFICATE_MANAGER_CONFIRM_DELETE_MESSAGE'),
			buttons: MessageBoxButtons.YES_NO,
			onYes: (messageBox, button, event) => {
				button.setWaiting();

				messageBox.getButtons()
					.forEach(
						(button) => {
							if (button.isWaiting()) {
								return;
							}

							button.setDisabled(true);
						}
					);

				BX.ajax.runAction(
					'fusion:certificate.Certificate.delete',
					{
						data: {
							certificateId: id
						}
					}
				).then(
					(response) => {
						messageBox.close();

						EventEmitter.emit(
							window, 
							'BX.Fusion.Certificate:onCertificateDelete', 
							{}
						);
					},
					(response) => {
						const errors = [];

						for (let i = 0; i < response.errors.length; i++)
						{
							errors.push(
								BX.util.nl2br(response.errors[i].message)
							);
						}

						messageBox.close();

						MessageBox.show({
							title: Loc.getMessage('JS_FUSION_CERTIFICATE_MANAGER_ERROR_TITLE'),
							message: errors.join('<br><br>'),
							buttons: MessageBoxButtons.OK,
							onOk: (errorMessageBox, errorMessageBoxButton, errorMessageBoxEvent) => {
								errorMessageBox.close();
							}
						});

					}
				);
			},
		});
	}
}